/**
 * 导入类型声明
 */
import type { ClientPlatform } from '../../types';

/**
 * 是否是鸿蒙系统
 * 注意：鸿蒙 UA 同时包含 harmony 和 android，需优先判断
 */
export const isHarmonyOs = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  return ua.includes('harmony');
};

/**
 * 是否是安卓系统
 * 注意：鸿蒙设备 UA 也包含 android，需排除鸿蒙后才是安卓
 */
export const isAndroid = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  return ua.includes('android') && !ua.includes('harmony');
};

/**
 * 是否是 iOS/iPadOS 系统
 * iPadOS 13+ 的桌面模式会使用 Mac 身份，需结合多点触控能力判断
 */
export const isIOS = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  const platform: string = (navigator.platform || '').toLowerCase();
  const isKnownIOSDevice = ['iphone', 'ipad', 'ipod'].some((device) => ua.includes(device));
  const isIPadDesktopMode = (ua.includes('macintosh') || platform === 'macintel') && navigator.maxTouchPoints > 1;

  return isKnownIOSDevice || isIPadDesktopMode;
};

/**
 * APP内部使用小鹅通的webview加载的小鹅通h5静态资源，
 * 无法识别hrhg的APP标识，需要单独判断
 * @returns {boolean}
 */
export const isInXetApp = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  // 小鹅通APP的SDK中的ua标识, XiaoEPaaS;iOS-1.0.25;
  return ua.includes('xiaoepaas');
};

/**
 * 是否在APP内部
 */
export const isInApp = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  return ua.includes('hrhg_new_') || isInXetApp();
};

/**
 * 获取当前平台类型
 */
export const getPlatform = (): ClientPlatform => {
  if (isHarmonyOs()) {
    return 'harmony';
  }
  if (isIOS()) {
    return 'ios';
  }
  if (isAndroid()) {
    return 'android';
  }
  return 'android';
};
